<template>
  <div>
    <div class="user input">
      <span></span>
      <input id="name" v-model="loginForm.fdNumber" type="text" autocomplete="off" placeholder="请输入账号" />
    </div>
    <div class="password input">
      <span></span>
      <input id="password" v-model="loginForm.fdPassword" type="password" autocomplete="off" placeholder="请输入密码" />
    </div>
    <div class="login_btn">
      <el-button type="primary" @click="login">登录</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        school_id: '46',
        fdNumber: '120admin',
        fdPassword: '0adminvan.ber'
      }
    };
  },
  created() {},
  methods: {
    async login() {
      let res = await this.$api.login.loginIn(this.loginForm);
      if (res.code === 0) {
        this.$message({
          message: '登录成功！',
          type: 'success',
          center: true
        });
        if (res.data) {
          // localStorage.setItem("fdName", res.data.fdName);
          // localStorage.setItem("school_id", res.data.fdSchoolId);
          // localStorage.setItem("school_name", res.data.school_name);
          // localStorage.setItem("user_type", res.data.fdUserType);

          // document.cookie=`token = school_session:${res.data.id}`
          this.$store.commit('setUserInfo', JSON.stringify(this.$until.methods.deleteNullPrototype(res.data)));

          this.$store.commit('setToken', JSON.stringify(123));

          // this.$router.push('/');
          this.$router.push({
            path: '/demoList'
          });
          // Cookies.set("token", `school_session:${res.data.id}`);
          // let instituteObj={}
          // let institute=JSON.parse(res.data.fdSerializeExtra)
          // if(institute.struct&&institute.user_type==2){
          //   instituteObj.id=institute.struct.split(',')[0]
          //   localStorage.setItem("instituteObj_id", instituteObj.id);
          //   instituteObj.fdName=institute.cn_struct[0][0]
          //   localStorage.setItem("instituteObj_fdName", instituteObj.fdName);
          //  this.$store.commit('setInstituteObj', instituteObj)
          // }
        }
      } else {
        this.$message({
          message: res.msg,
          center: true
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
</style>